/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { markupContentStyles, syntaxHighlightStyles } from 'src/styles/markup';

export const ReadmeContainer = styled.article(
  {
    border: `1px solid ${token('color.border')}`,
    borderRadius: token('border.radius'),
    padding: token('space.200'),
  },
  markupContentStyles,
  syntaxHighlightStyles
);

export const ReadmeHeader = styled.span({
  font: token('font.heading.small'),
  marginTop: token('space.300'),
});

export const ReadmeIcon = styled.span({
  '> span': {
    verticalAlign: 'sub',
  },
});
